/**
 * Template - Data mapper for RFI1 - Packaging
 * Section UID (in template) : Section Path in data
 */
export const rfi1PackagingSectionMapper = {
  //Business Capabilities
  primary_packaging_capabilities:
    'dynamic_sections.business_capability.primary_packaging_capabilities',
  design_capabilities:
    'dynamic_sections.business_capability.design_capabilities',
  certifications: 'dynamic_sections.business_capability.certifications',
  packaging_business_intelligence:
    'dynamic_sections.business_capability.packaging_business_intelligence',

  //Supply Chain
  production_location: 'dynamic_sections.supply_chain.production_location',
  fulfillments_location: 'dynamic_sections.supply_chain.fulfillments_location',

  //Responsible Sourcing
  responsible_sourcing_sustainability:
    'dynamic_sections.responsible_sourcing.responsible_sourcing_sustainability',

  //Other Information
  packaging_supplier_employee_information:
    'dynamic_sections.other_information.packaging_supplier_employee_information',
  top_retail_and_brands_and_business_value:
    'dynamic_sections.other_information.top_retail_and_brands_and_business_value',
}
